module.exports = __webpack_public_path__ + "static/media/chev-right.4e5419e5.svg";